import * as React from "react";
import { Image } from "react-native";

export default function (props) {
  return (
    <Image
      resizeMode='contain'
      style={{
        marginTop: 20,
        height: 80,
        alignSelf: "center",
        maxWidth: 120,
        width: "100%",
        ...props.style,
      }}
      source={require("../assets/images/Villaquilambre.png")}></Image>
  );
}
